/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
    getErrorDetailsFn,
    getInputFieldProps,
    onlyNumberInput,
    removeSpecialCharAndNumFn,
    safeToString,
    sliceText,
} from "../../../../utils/common";
import useAPIHandler from "../../../../hook/use-api-handler";
import { LwfSchema } from "./lwf-validation";
import { LWF_INITIAL_STATE } from "./lwf-constant";
import { logger, safeString } from "../../../../utils/logger";


const useLwfService = ({ openSnackbar }) => {
    const [lwf, setLwf] = useState(LWF_INITIAL_STATE);
    const [lwfListinfo, setLwfListinfo] = useState([]);
    const [errors, setErrors] = useState({});
    const [allState, setAllState] = useState([]);

    const { fetchData } = useAPIHandler();

    async function lwfLists() {
        try {
            const URL = "/admin/labour-welfare-fund";
            const METHOD = "GET";

            try {
                const result = await fetchData({
                    url: URL,
                    method: METHOD,
                });

                setLwfListinfo(result.data);
            } catch (err) {
                logger.error("Error fetching organizations:", err);
            }
        } catch (error) {
            logger.log(error)
        }
    }

    const fetchAllState = async () => {

        try {
            const response = await fetchData({
                url: '/common/state',
                method: "GET",
            })
            if (response?.status === 'success' && Array.isArray(response?.data)) {
                const mappedData = response?.data?.map((item) => ({
                    id: item?.state_id,
                    name: item?.state_name
                }))
                setAllState(mappedData)
            }
        } catch (error) {
            logger.log(error,"LLL")
        }

    }

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }

        if (name === "employee_contribution") {
            value = sliceText(onlyNumberInput(safeString(value), 150))
        }

        if (name === "employer_contribution") {
            value = sliceText(onlyNumberInput(safeString(value), 150))
        }


        setLwf((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }));

        const fieldSchema = LwfSchema.extract(name);
        const { error } = fieldSchema.validate(value);

        if (!error) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: error ? error.details[0].message : undefined,
            }));
        }
    }

    function handleBlurFn(e, name) {
        let value = e;

        if (e && e.target) {
            value = e.target.value;
        }

        const fieldSchema = LwfSchema.extract(name);
        const { error } = fieldSchema.validate(value);

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error ? error.details[0].message : undefined,
        }));
    }



    const handleSubmit = async () => {
        try {
            const { employee_contribution, employer_contribution, decuction_cycle } = lwf;
    
            // Validate input
            const { error } = LwfSchema.validate(
                { employee_contribution, employer_contribution, decuction_cycle, state_id: 2 },
                { abortEarly: false }
            );
    
            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                      acc[err.path.join(".")] = err.message;
                      return acc;
                  }, {})
                : {};
    
            setErrors(validationErrors);
    
            if (Object.keys(validationErrors).length > 0) {
                return;
            }
    
            // API call
            const response = await fetchData({
                url: "/admin/esi",
                method: "POST",
                data: {
                    employee_contribution,
                    employer_contribution,
                    decuction_cycle,
                    state_id: 2,
                },
            });
    
            if (response.status === "success") {
                setLwf(LWF_INITIAL_STATE);
                openSnackbar({ message: "ESI Created Successfully", color: "success" });
                lwfLists();
            } else {
                throw new Error(response.message || "An unexpected error occurred");
            }
        } catch (error) {
            handleAPIError(error);
        }
    };
    
    const handleUpdate = async (id) => {
        try {
            const { employee_contribution, employer_contribution, deduction_type } = lwf;
    
            // Validate input
            const { error } = LwfSchema.validate(
                { state_id: 5, employee_contribution, employer_contribution, deduction_type },
                { abortEarly: false }
            );
    
            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                      acc[err.path.join(".")] = err.message;
                      return acc;
                  }, {})
                : {};
    
            setErrors(validationErrors);
    
            if (Object.keys(validationErrors).length > 0) {
                return false;
            }
    
            // Prepare data based on deduction type
            let data = {
                state_id: 5,
                employee_contribution,
                employer_contribution,
                deduction_type,
            };
    
            if (deduction_type === "Half Yearly") {
                data = {
                    ...data,
                    first_deduction_month: "April",
                    second_deduction_month: "October",
                };
            } else {
                data = {
                    ...data,
                    first_deduction_month: "October",
                };
            }
    
            // API call
            const response = await fetchData({
                url: `/admin/labour-welfare-fund/update/${id}`,
                method: "POST",
                data,
            });
    
            if (response.status === "success") {
                setLwf(LWF_INITIAL_STATE);
                openSnackbar({ message: "LWF Updated Successfully", color: "success" });
                lwfLists();
                return true;
            } else {
                throw new Error(response.message || "An unexpected error occurred");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };
    
    const handleAPIError = (error) => {
        if (error?.type === "JoiValidationError") {
            const errorsAll = {};
            error?.errors?.reduce((acc, curr) => {
                const { field, message } = curr;

                errorsAll[field] = message;

                return acc;
            });
            openSnackbar({
                message:
                    Object.keys(errorsAll).length > 0
                        ? "Validation Error!"
                        : "Something went wrong!",
                color: "danger",
            });
            setErrors(errorsAll);
        }
        else if (error?.type === "GeneralError") {
            const backendMessage = typeof error.message === "string"
                ? error.message
                : "An unexpected error occurred.";

            openSnackbar({
                message: backendMessage,
                color: "danger",
            });
        }
        logger.log(error)
    };
    

    useEffect(() => {
        lwfLists()
        fetchAllState()
    }, []);



    return {
        lwfListinfo,
        setLwf,
        lwf,
        errors, 
        setErrors,
        handleBlurFn,
        handleChange,
        handleSubmit,
        handleUpdate,
        allState
    };
};

export default useLwfService;